import { render, staticRenderFns } from "./infotip-hot.vue?vue&type=template&id=2b6c179e"
import script from "./infotip-hot.vue?vue&type=script&lang=js"
export * from "./infotip-hot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports